import { ProgressBar, Text } from "@jds/core";
import classes from "./ReindexAlert.module.css";
import { useParams } from "react-router-dom";
import { useContext } from "react";
import { FileUploadContext } from "../../Layout/FileUploadLayout";
const ReindexAlert = ({ shadow = true }) => {
  const { id: eventId } = useParams();
  const { reindexProgress } = useContext(FileUploadContext);
  const clusteringProgressPercentage =
    reindexProgress?.[eventId]?.clusteringProgressPercentage || 0;
  const croppingProgressPercentage =
    reindexProgress?.[eventId]?.croppingProgressPercentage || 0;
  const progessValue =
    (clusteringProgressPercentage + croppingProgressPercentage) / 200;
  return (
    <>
      <div
        className={`${classes["reindex-section"]} ${
          shadow && classes["reindex-shadow"]
        }`}
      >
        <Text text={`Your photo is being reindexed.`} appearance="heading_xs" />
        <Text
          text={`Please wait while we optimize the clustering.`}
          appearance="body_s"
        />
        <div
          style={{
            width: "100%",
          }}
        >
          <ProgressBar
            label="Processing..."
            value={progessValue}
            valueLabel={`${Math.round(progessValue * 100)}%`}
          />
        </div>
      </div>
    </>
  );
};

export default ReindexAlert;
